/**
 * Persistent provider for company-scoped realtime subscriptions.
 * Consolidates shifts + attendance_event_flags into a single channel.
 * 
 * Mounted in AuthenticatedRoutesLayout — survives route navigation.
 */

import { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useCompanySettings, isOffersEnabled } from '@/hooks/useCompanySettings';
import { useCompanyRealtimeSubscription } from '@/hooks/realtime/useCompanyRealtimeSubscription';

interface CompanyRealtimeProviderProps {
  children: ReactNode;
}

export function CompanyRealtimeProvider({ children }: CompanyRealtimeProviderProps) {
  const { profile } = useAuth();
  const { settings: companySettings } = useCompanySettings();
  const companyId = profile?.company_id;
  const offersEnabled = isOffersEnabled(companySettings);

  useCompanyRealtimeSubscription({
    companyId,
    offersEnabled,
    enabled: !!companyId,
  });

  return <>{children}</>;
}
